export default "__VITE_ASSET__z44ANzEw__"